/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.3.2",
  "gitBuildTime": "2024-05-13T20:47:36.232Z",
  "gitBuildVersion": "1.3.2",
  "gitCommitId": "1349fdf",
  "gitCommitIdFull": "1349fdf9c4b73c4d5ad213b6991ac393d4bd11f5",
  "gitCommitTime": "2024-05-13T20:46:16.000Z",
  "version": "1.3.2-2024-05-13T20:46:16.000Z-(1349fdf)"
};
